import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import './style/details.css'
import xiaz from '../../assets/download.png'
import { message } from 'antd'
import { Base64 } from 'js-base64'

export default function Details() {
  const item = useLocation().search

  const details = JSON.parse(Base64.decode(item.slice(6)))
  console.log(details)
  useEffect(() => {
    document.title = `${details.soft_name}-官方免费下载`
    window.scrollTo(0, 0)
  }, [details])
  //下载
  function download(url, filename) {
    message.success('正在努力下载中.......')
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    link.click()
  }
  //截取
  const splic = details.detail_desc.split('___')

  return (
    <>
      <div className="deta_center">
        <div className="top">
          <div className="top_left">
            <img src={details.icon_url} alt="" />
          </div>
          <div className="top_right">
            <p className="name">{details.soft_name}</p>
            <p className="omne">
              <i></i> 官方 年满<span>{details.soft_age}</span>
            </p>
            <p className="info">{details.short_desc}</p>
            <p className="down">
              {details.download_count > 10000 ? (
                <>
                  <span className="big">
                    {Math.floor(details.download_count / 10000)}
                  </span>
                  <span className="small">万次下载</span>
                </>
              ) : (
                <>
                  <span className="big">{details.download_count}</span>
                  <span className="small">次下载</span>
                </>
              )}
              <i className="fgx"></i>
              <span className="big">{details.remark_count}</span>
              <span className="small">人评论</span>
            </p>
          </div>
          <div className="t_p_bottom">
            <button
              className="ordinary"
              onClick={() => download(details.normal_url)}>
              <img src={xiaz} alt="" /> 普通下载
            </button>
            <button
              className="speed"
              onClick={() => download(details.hight_speed_url)}>
              <img src={xiaz} alt="" />
              高速下载({' '}
              {details.size > 1024 ? (
                <span>{Math.floor(details.size / 1024)}MB</span>
              ) : (
                <span>{details.size}KB</span>
              )}
              )
            </button>
          </div>
        </div>
        <div className="abc">
          <span className="icon"></span>
          <span className="icon_span">人工检测，安心下载</span>
          <span className="icons"></span>
          <Link to={'/complaint'}>
            <span className="icons_span">软件投诉</span>
          </Link>
        </div>
        <div className="info_all">
          <div className="i_all_top">
            <ul>
              <li className="li_after">
                <p>版本</p>
                <span>{details.version}</span>
              </li>
              <li className="li_after">
                <p>分类</p>
                <span>{details.sub_soft_type.type_desc}</span>
              </li>
              <li className="li_after">
                <p>大小</p>
                {details.size > 1024 ? (
                  <span>{Math.floor(details.size / 1024)}MB</span>
                ) : (
                  <span>{details.size}KB</span>
                )}
              </li>
              <li className="li_after">
                <p>语言</p>
                <span>{details.language}</span>
              </li>
              <li>
                <p>时间 </p>
                <span>{details.publish_date}</span>
              </li>
            </ul>
          </div>
          <div className="i_all_bottom">
            <ul className="screenshot">
              {details.image_url ? (
                <li>
                  <div className="jietu">
                    <span></span>应用截图
                  </div>
                  <img src={details.image_url} alt="" />
                </li>
              ) : (
                <></>
              )}

              <li>
                <div className="jietu">
                  <span></span>应用描述
                </div>
                <div className="jianjie">
                  <span>&nbsp;&nbsp; &nbsp;&nbsp; {splic[0]}</span>
                </div>
              </li>
              <li>
                <div className="jietu">
                  {/* 换行符 */}
                  <span></span>更新说明
                </div>
                <div className="jianjie">
                  {splic[1] ? (
                    <span>&nbsp;&nbsp; &nbsp;&nbsp;{splic[1]}</span>
                  ) : (
                    <span>&nbsp;&nbsp; &nbsp;&nbsp;暂无更新日志说明</span>
                  )}
                </div>
              </li>

              <li>
                <div className="jietu">
                  {/* 换行符 */}
                  <span></span>其他信息
                </div>
                <div className="jianjie">
                  <span>
                    &nbsp;&nbsp; &nbsp;&nbsp; 开发商{' '}
                    {splic[2] ? splic[2] : details.soft_name}
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}
